import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section id="oferta" className="py-20 px-6 bg-white" data-id="element-142">
      <div className="max-w-3xl mx-auto text-center" data-id="element-143">
        <FadeIn data-id="element-144">
          <h2 className="text-3xl sm:text-4xl text-taupe mb-6 leading-tight" data-id="element-145">
            Recupera tu descanso por menos de lo que cuesta un paquete de
            pañales.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-146">
          <div className="my-10 p-8 bg-cream rounded-3xl border-2 border-amber/20 relative inline-block" data-id="element-147">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-amber text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-148">
              Oferta Especial
            </div>
            <p className="text-taupe/80 mb-2" data-id="element-149">
              Obtén el Protocolo completo por solo
            </p>
            <div className="text-taupe/50 line-through text-2xl mb-1" data-id="element-150">
              $19 USD
            </div>
            <div className="text-6xl font-serif text-amber mb-2" data-id="element-151">
              $14 <span className="text-2xl" data-id="element-152">USD</span>
            </div>
            <p className="text-sage font-medium flex items-center justify-center gap-2" data-id="element-153">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-154">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" data-id="element-155"></path>
                <polyline points="7 10 12 15 17 10" data-id="element-156"></polyline>
                <line x1="12" y1="15" x2="12" y2="3" data-id="element-157"></line>
              </svg>
              Descarga inmediata
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-158">
          <div className="max-w-[200px] mx-auto mb-8" data-id="element-159">
            <img src="https://cdn.magicpatterns.com/uploads/b6Nm7KhV6hYQPGboThVEhf/Protocolo_de_los_15_minutos.png" alt="El Protocolo de los 15 Minutos" className="w-full rounded-xl shadow-md" data-id="element-160" />
          </div>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-161">
          <CTAButton href="https://casaencalma.com/cart/51256026595623:1" data-id="element-162" />
        </FadeIn>
      </div>
    </section>;
}